<template>
  <cms-modal unique="view-vessel-manning-history" title="View Manning History" size="lg">

    <form @submit.prevent="confirmUpdateVesselManningHistory">

      <div class="form-group form-row mb-1" :class="{'has-error': vesselManningHistoryErrors.manning_from_id}">
        <label for="manning-from-id" class="col col-sm-3 col-form-label font-weight-bolder">
           From:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <select id="manning-from-id" class="form-control form-control-xs"
                  :class="{'bg-table-hover': otherFrom}"
                  v-model="vesselManningHistory.manning_from_id"
                  @change="showOtherFrom"
                  :disabled="!editable"
          >
            <option class="bg-white" :value="null">--- OTHER MANNING FROM ---</option>
            <option class="bg-white" v-for="manningKey in allManningKeys" :key="manningKey.id"
                    :value="manningKey.id">
              {{ manningKey.name }}
            </option>
            <option value="" class="bg-warning">--- Other ---</option>
          </select>
          <span class="help-block" v-if="vesselManningHistoryErrors.manning_from_id !== ''">
            <small><strong>{{ vesselManningHistoryErrors.manning_from_id }}</strong></small>
          </span>
        </div>
      </div>

      <div class="form-group form-row mb-1" v-if="otherFrom">
        <label for="other-management-from2" class="col col-sm-3 col-form-label font-weight-bolder">
          Other:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="text" id="other-management-from2"
                 class="form-control form-control-xs"
                 placeholder="Specify Management Name for this record"
                 v-model="vesselManningHistory.other_manning_from"
                 :readonly="!editable"
          >
        </div>
      </div>

      <div class="form-group form-row mb-1" :class="{'has-error': vesselManningHistoryErrors.manning_to_id}">
        <label for="manning-to-id" class="col col-sm-3 col-form-label font-weight-bolder">
           To:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <select id="manning-to-id" class="form-control form-control-xs"
                  :class="{'bg-table-hover': otherTo}"
                  v-model="vesselManningHistory.manning_to_id"
                  @change="showOtherTo"
                  :disabled="!editable"
          >
            <option class="bg-white" :value="null">--- OTHER MANNING TO ---</option>
            <option class="bg-white" v-for="manningKey in allManningKeys" :key="manningKey.id"
                    :value="manningKey.id">
              {{ manningKey.name }}
            </option>
            <option value="" class="bg-warning">--- Other ---</option>
          </select>
          <span class="help-block" v-if="vesselManningHistoryErrors.manning_to_id !== ''">
            <small><strong>{{ vesselManningHistoryErrors.manning_to_id }}</strong></small>
          </span>
        </div>
      </div>

      <div class="form-group form-row mb-1" v-if="otherTo">
        <label for="other-management-from2" class="col col-sm-3 col-form-label font-weight-bolder">
          Other:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="text" id="other-management-to"
                 class="form-control form-control-xs"
                 placeholder="Specify Management Name for this record"
                 v-model="vesselManningHistory.other_manning_to"
                 :readonly="!editable"
          >
        </div>
      </div>

<!--      <div class="form-group form-row mb-1" :class="{'has-error': vesselManningHistoryErrors.date_from}">-->
<!--        <label for="date-from" class="col col-sm-3 col-form-label font-weight-bolder">-->
<!--          Date From:-->
<!--        </label>-->
<!--        <div class="col col-sm-8 offset-1 col-form-label p-0">-->
<!--          <input type="date" id="date-from" v-if="editable"-->
<!--                 class="form-control form-control-xs"-->
<!--                 v-model="vesselManningHistory.date_from"-->
<!--          >-->
<!--          <input type="text" readonly v-else-->
<!--                 class="form-control form-control-xs"-->
<!--                 placeholder="Start Date Not Specified"-->
<!--                 :value="vesselManningHistory.date_from | moment('D MMMM YYYY')"-->
<!--          >-->
<!--          <span class="help-block" v-if="vesselManningHistoryErrors.date_from !== ''">-->
<!--                      <small><strong>{{ vesselManningHistoryErrors.date_from }}</strong></small>-->
<!--                    </span>-->
<!--        </div>-->
<!--      </div>-->

      <div class="form-group form-row mb-1" :class="{'has-error': vesselManningHistoryErrors.date_transferred}">
        <label for="date-to" class="col col-sm-3 col-form-label font-weight-bolder">
          Date Transferred:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="date" id="date-to" v-if="editable"
                 class="form-control form-control-xs"
                 v-model="vesselManningHistory.date_transferred"
          >
          <input type="text" readonly v-else
                 class="form-control form-control-xs"
                 placeholder="End Date Not Specified"
                 :value="vesselManningHistory.date_transferred | moment('D MMMM YYYY')"
          >
          <span class="help-block" v-if="vesselManningHistoryErrors.date_transferred !== ''">
                      <small><strong>{{ vesselManningHistoryErrors.date_transferred }}</strong></small>
                    </span>
        </div>
      </div>

<!--      <div class="form-group form-row mb-1" :class="{'has-error': vesselManningHistoryErrors.active}">-->
<!--        <label for="new-status" class="col col-sm-3 col-form-label font-weight-bolder">-->
<!--          Active:-->
<!--        </label>-->
<!--        <div class="col col-sm-8 offset-1 col-form-label p-0">-->
<!--          <select id="new-status" class="form-control form-control-xs"-->
<!--                  v-model="vesselManningHistory.active"-->
<!--                  :disabled="!editable"-->
<!--          >-->
<!--            <option value="1"> Active</option>-->
<!--            <option value="0"> Inactive</option>-->
<!--          </select>-->
<!--          <span class="help-block" v-if="vesselManningHistoryErrors.active !== ''">-->
<!--                              <small><strong>{{ vesselManningHistoryErrors.active }}</strong></small>-->
<!--                            </span>-->
<!--        </div>-->
<!--      </div>-->

      <hr />
      <div class="float-right">
        <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder"
                v-if="isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal">
          <i class="fas fa-edit"></i>
          {{ editable ? 'Update' : 'Edit' }}
        </button>
        <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                v-if="editable"
                @click="cancelEdit"
        >
          <span class="fas fa-ban"></span>
        </button>
      </div>

    </form>
  </cms-modal>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {gateMixin} from '@/mixins/gateMixin';
import CmsModal from '@/components/elements/CmsModal';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'EditManningHistory',

  mixins: [vueAppMixin, formMixin, gateMixin],

  components: {CmsModal},

  props: {
    viewVesselManningHistory: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      vesselManningHistory: {},
      vesselManningHistoryErrors: {},
      editable: false,
      editFields: [
        'id',
        'manning_from_id',
        'manning_to_id',
        'other_manning_from',
        'other_manning_to',
        'date_transferred',
      ],

      otherFrom: false,
      otherTo: false,

    };
  },

  methods: {
    ...mapActions([
      'updateVesselManningHistory',
    ]),

    async confirmUpdateVesselManningHistory() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = {};
          this.editFields.forEach(key => {
            let value = this.vesselManningHistory[key] ? this.vesselManningHistory[key] : '';
            if (value === '0000-00-00') value = '';
            params[key] = value;
          });
          let updatedVesselManningHistory = await this.updateVesselManningHistory(params);
          if (updatedVesselManningHistory) {
            if (updatedVesselManningHistory.errors) {
              this.vesselManningHistoryErrors = updatedVesselManningHistory.errors;
            } else {
              this.successAlert('Manning Vessel History Record Successfully Updated', 'UPDATE');
              document.getElementById('close-view-vessel-manning-history').click();
              this.vesselManningHistory = Object.assign({}, updatedVesselManningHistory);
              this.vesselManningHistoryErrors = {};
            }
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelEdit() {
      this.editable = false;
      // this.otherFrom = false;
      // this.otherTo = false;
      this.vesselManningHistory = Object.assign({}, this.viewVesselManningHistory);
    },

    // show input if others
    showOtherFrom: function(e) {
      this.otherFrom = e.target.value === '';
    },

    showOtherTo: function(e) {
      this.otherTo = e.target.value === '';
    },

  },

  computed: {
    ...mapGetters([
      'allManningKeys',
      'vesselInfo',
    ]),
  },

  watch: {
    'viewVesselManningHistory'() {
      this.vesselManningHistory = Object.assign({}, this.viewVesselManningHistory);
      this.editable = false;
    },

    'vesselManningHistory.other_manning_from'() {
      if (this.vesselManningHistory.other_manning_from) {
        this.otherFrom = true;
      }else {
        this.otherFrom = false;
      }
    },

    'vesselManningHistory.manning_from_id'() {
      if (this.vesselManningHistory.manning_from_id) {
        this.vesselManningHistory.other_manning_from = null;
      }
    },


    'vesselManningHistory.other_manning_to'() {
      if (this.vesselManningHistory.other_manning_to) {
        this.otherTo = true;
      }else {
        this.otherTo = false;
      }
    },

    'vesselManningHistory.manning_to_id'() {
      if (this.vesselManningHistory.manning_to_id) {
        this.vesselManningHistory.other_manning_to = null;
      }
    },

  },

};
</script>

<style scoped>

</style>
